/**
 * Teste dos dois verdes do logo do DevClub (01/11/2026). O index.html lê
 * ?verde=tradicional|novo, lembra no navegador e grava em <html data-verde>.
 * O padrão é o verde novo, o mesmo lima da interface.
 */
export type DevClubVerde = 'tradicional' | 'novo';

export function devClubVerde(): DevClubVerde {
  return document.documentElement.dataset.verde === 'tradicional'
    ? 'tradicional'
    : 'novo';
}

/** O SVG transparente do símbolo no verde escolhido. */
export function devClubMarkSrc(): string {
  return `/brand/logos/devclub-verde-${devClubVerde()}.svg`;
}
